var $airlines;

$(document).ready(function() {
	$airlines = $(".searchFilterAirline");

	$(".searchFilterAirline:checkbox").on("click", function(){
		charterSearchFilter();
		$('#resetFilterAirline').show();
	});
});

var charterSearchFilter = function () {	
	var getFilter = function (){	
		var airlines = [];
		$airlines.each(function(index, item){
			 if($(item).prop("checked")){
				 airlines.push(item.value);
			 }
		});
		return {
			airlines:airlines
		}
	}
	
	$( document ).trigger( "charter_filter_event", getFilter());
	
}

function resetFilterAirline() {
	$('.searchFilterAirline').prop('checked', true);
	
	$('#resetFilterAirline').hide();
	charterSearchFilter();
}

function unselectAllFilterAirline() {
	$('.searchFilterAirline').prop('checked', false);
}
